import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-starred",
  "use": "icon-starred-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-starred\">\n  <path d=\"M512 64l144.448 292.864 323.008 46.912-233.728 227.84 55.168 321.728L512 810.688l-288.896 142.656 55.168-321.728L44.544 403.776l323.008-46.912L512 64z\" fill=\"#ffd700\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol